import React, { Component } from "react";
import { connect } from "react-redux";
import { selectAccountChecklist } from "reducers/account/checklists";
import FieldGroup from "components/Common/Forms/FieldGroup";
import Input from "components/Common/Forms/Input";
import Textarea from "components/Common/Forms/Textarea";

export class ListContent extends Component {
  updateChecklistDescriptionText = input =>
    this.props.updateChecklistTextToken("descriptionText", input);

  updateChecklistHeaderText = input =>
    this.props.updateChecklistTextToken("headerText", input);

  render() {
    const { headerText, descriptionText } = this.props;

    return (
      <div>
        <h2>List Content</h2>
        <FieldGroup title="Main Heading" className="configuration-item">
          <Input
            type="text"
            className="checklist-text-short"
            value={headerText}
            placeholder="Welcome!"
            onChange={this.updateChecklistHeaderText}
          />
        </FieldGroup>
        <FieldGroup title="Description Text" className="configuration-item">
          <Textarea
            type="text"
            className="checklist-textarea-long"
            value={descriptionText}
            onChange={this.updateChecklistDescriptionText}
          />
        </FieldGroup>
      </div>
    );
  }
}

const mapStateToProps = (state, { checklistId }) => {
  const checklist = selectAccountChecklist(state, checklistId);
  const headerText = checklist.textTokens && checklist.textTokens.headerText;
  const descriptionText =
    checklist.textTokens && checklist.textTokens.descriptionText;

  return {
    descriptionText,
    headerText
  };
};

export default connect(mapStateToProps)(ListContent);
